import FullStack from "./assets/products/full-stack.jpg";
import DataSciens from "./assets/products/ds.jpg";
import Java from "./assets/products/java.jpg";
import ReactJs from "./assets/products/react.jpg";

let Courses = [
  {
    name: "Full Stack Web Development",
    description:
      "Full Stack Web-Applications (Front-End, Back-End, Database, REST APIs). Learn Mongo-Express-React-NodeJS with hands-on training at VK Learning.",
    image: FullStack,
    button: "Enroll Now",
  },
  {
    name: "Data Science",
    description:
      "Data Science Common core (EDA, Tools, Maths), Data Science & Machine Learning with Analytics: Tableau, SQL, Excel, PA, ML; Deep Learning with AI.",
    image: DataSciens,
    button: "Comming Soon",
  },
  {
    name: "Java Application Development",
    description:
      "This Full Stack Java Developer Program in India is designed to give you an essence of front-end, middleware, and back-end Java web developer technologies. ",
    image: Java,
    button: "Comming Soon",
  },
  {
    name: "ReactJS Traning",
    description:
      "React is a declarative, efficient, and flexible JavaScript library for building Web Applications. It follows component-based approach.  ",
    image: ReactJs,
    button: "Enroll Now",
  },
];

export default Courses;
